import { gql } from '@apollo/client'

import { useValidateOabModalContext } from '../context'
import { StepRenderer_RootFragment } from './__generated__/step-renderer.graphql'
import { ConfirmId } from './confirm-id'
import { ConfirmOab } from './confirm-oab'
import { EmailSent } from './email-sent'
import { OabTransferring } from './oab-transferring'
import { OabTransferringError } from './oab-transferring-error'
import { OabTransferringSuccess } from './oab-transferring-success'
import { Validating } from './validating'
import { ValidatingError } from './validating-error'
import { ValidatingSuccess } from './validating-success'

export type StepRendererProps = {
  root: StepRenderer_RootFragment
}

export function StepRenderer(props: StepRendererProps) {
  const context = useValidateOabModalContext()

  const { step } = context

  switch (step) {
    case 'confirmId':
      return <ConfirmId />
    case 'confirmOab':
      return <ConfirmOab {...props} />
    case 'validating':
      return <Validating />
    case 'validatingSuccess':
      return <ValidatingSuccess />
    case 'validatingError':
      return <ValidatingError />
    case 'emailSent':
      return <EmailSent />
    case 'oabTransferring':
      return <OabTransferring />
    case 'oabTransferringSuccess':
      return <OabTransferringSuccess />
    case 'oabTransferringError':
      return <OabTransferringError />
    default:
      throw new Error(`Unknown step: ${step}`)
  }
}

StepRenderer.fragments = {
  root: gql`
    fragment StepRenderer_root on RootApi {
      ...ConfirmOab_root
    }

    ${ConfirmOab.fragments.root}
  `,
}
